import { Table, TableContainer, TableHead, TableHeader, TableRow } from '@ksyos/design-system';
import type { IRequest } from '../../../../../common/interfaces/request';
import type { PatientTaskListHeader } from './PatientTasksList';
import { translateKey } from '../../../../translate';
import { RequestsListBody } from './RequestsListBody';

export type RequestListHeader =
    | 'statusLabel'
    | 'patientName'
    | 'birthDate'
    | 'type'
    | 'startedBy'
    | 'careProvider'
    | 'sortDate';
export type SortDirection = 'ASC' | 'DESC';

interface IRequestsListProps {
    onSort?: (sortBy: RequestListHeader) => Promise<void>;
    requests: IRequest[];
    sortableHeaders?: RequestListHeader[];
    sortBy?: RequestListHeader | PatientTaskListHeader;
    sortDirection?: SortDirection;
}

export function RequestsList(props: IRequestsListProps) {
    if (!props.requests || props.requests.length === 0) {
        return null;
    }

    function handleOnSort(header: RequestListHeader) {
        if (props.onSort) {
            props.onSort(header);
        }
    }

    const headers: { key: RequestListHeader; label: string }[] = [
        { key: 'statusLabel', label: translateKey('request.status') },
        { key: 'patientName', label: translateKey('request.patientName') },
        { key: 'birthDate', label: translateKey('common.birthDate') },
        { key: 'type', label: translateKey('common.type') },
        { key: 'startedBy', label: translateKey('request.startedBy') },
        { key: 'careProvider', label: translateKey('patient.careProvider') },
        { key: 'sortDate', label: translateKey('request.lastUpdated') },
    ];

    return (
        <TableContainer>
            <Table
                data-automation-test="requests-table"
                spacing="medium"
            >
                <TableHead>
                    <TableRow>
                        {headers.map((header) => (
                            <TableHeader
                                isSortable={props.sortableHeaders?.includes(header.key)}
                                isSortHeader={props.sortBy === header.key}
                                key={header.key}
                                onClick={() => handleOnSort(header.key)}
                                sortDirection={props.sortBy === header.key ? props.sortDirection : undefined}
                            >
                                {header.label}
                            </TableHeader>
                        ))}
                    </TableRow>
                </TableHead>
                <RequestsListBody requests={props.requests} />
            </Table>
        </TableContainer>
    );
}
